import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-0.5,-2.5h1v0.5h-1zM0,-2h0.5v3h-0.5zM0,1h1v0.5h-1zM-1,1.5h2v0.5h-2z' },
    {
      paint: [
        ['haybale', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-0.5,-2h0.5v3.5h-0.5z',
    },
    {
      paint: 'ginkgoYellow',
      d: 'M-1.5,-6.5h3v0.5h-3zM-2.5,-6h3v0.5h-3zM1,-6h1.5v0.5h-1.5zM-2.5,-5.5h1v0.5h-1zM1.5,-5.5h1v0.5h-1zM-3,-5h1v0.5h-1zM0,-5h0.5v0.5h-0.5zM2,-5h1v0.5h-1zM-3.5,-4.5h3.5v0.5h-3.5zM2,-4.5h1.5v0.5h-1.5zM-3.5,-4h2.5v0.5h-2.5zM-0.5,-4h4v0.5h-4zM-3.5,-3.5h7v0.5h-7zM-3,-3h6v0.5h-6z',
    },
    {
      paint: 'autumnGold',
      d: 'M1,-5.5h0.5v0.5h-0.5zM0.5,-5h1.5v0.5h-1.5zM0,-4.5h2v0.5h-2zM-1,-4h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['ginkgoYellow', 0.64],
        ['parasolStripe', 0.36],
      ],
      d: 'M0.5,-6h0.5v0.5h-0.5zM-1.5,-5.5h2.5v0.5h-2.5zM-2,-5h2v0.5h-2z',
    },
  ],
  pixels: 113,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'autumnGold',
      d: 'M1,-5.5h0.5v0.5h-0.5zM0.5,-5h1.5v0.5h-1.5zM0,-4.5h2v0.5h-2zM-1,-4h0.5v0.5h-0.5zM-2,0.5h1.5v0.5h-1.5zM0.5,0.5h1v0.5h-1zM-2.5,1h0.5v0.5h-0.5zM-1.5,1h1v0.5h-1zM1.5,1h1v0.5h-1zM-2,1.5h1.5v0.5h-1.5zM1,1.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5zM-1,-3h2v0.5h-2zM-0.5,-2.5h1v0.5h-1zM0,-2h0.5v3.5h-0.5zM-0.5,1.5h1v0.5h-1z',
    },
    {
      paint: [
        ['haybale', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-1.5,-3.5h0.5v0.5h-0.5zM-0.5,-3.5h1v0.5h-1zM-0.5,-2h0.5v3.5h-0.5zM0.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'ginkgoYellow',
      d: 'M0,-6.5h1v0.5h-1zM-2,-6h2.5v0.5h-2.5zM1,-6h1v0.5h-1zM-2.5,-5.5h1v0.5h-1zM1.5,-5.5h1v0.5h-1zM-3,-5h1v0.5h-1zM0,-5h0.5v0.5h-0.5zM2,-5h0.5v1h-0.5zM-3,-4.5h3v0.5h-3zM-2.5,-4h1.5v0.5h-1.5zM-0.5,-4h3v0.5h-3zM-2,-3.5h0.5v0.5h-0.5zM-2,1h0.5v0.5h-0.5zM0.5,1h1v0.5h-1z',
    },
    {
      paint: [
        ['ginkgoYellow', 0.64],
        ['parasolStripe', 0.36],
      ],
      d: 'M0.5,-6h0.5v0.5h-0.5zM-1.5,-5.5h2.5v0.5h-2.5zM-2,-5h2v0.5h-2z',
    },
  ],
  pixels: 100,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'autumnGold',
      d: 'M1,-5.5h0.5v0.5h-0.5zM0.5,-5h1.5v0.5h-1.5zM0,-4.5h2v0.5h-2zM-1,-4h0.5v0.5h-0.5zM-2.5,0.5h2v0.5h-2zM0.5,0.5h1.5v0.5h-1.5zM-3,1h1v0.5h-1zM-1.5,1h1v0.5h-1zM1.5,1h1.5v0.5h-1.5zM-2.5,1.5h2v0.5h-2zM1,1.5h2v0.5h-2z',
    },
    {
      paint: 'trunk',
      d: 'M-1.5,-3.5h2.5v0.5h-2.5zM-1,-3h2v0.5h-2zM-0.5,-2.5h1v0.5h-1zM0,-2h0.5v3.5h-0.5zM-0.5,1.5h1v0.5h-1z',
    },
    {
      paint: [
        ['haybale', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-2,-4h0.5v0.5h-0.5zM0,-4h1v0.5h-1zM-0.5,-2h0.5v3.5h-0.5zM0.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'ginkgoYellow',
      d: 'M0.5,-6.5h0.5v0.5h-0.5zM-1.5,-6h2v0.5h-2zM1,-6h0.5v0.5h-0.5zM1.5,-5.5h0.5v0.5h-0.5zM0,-5h0.5v0.5h-0.5zM-2,-4.5h2v0.5h-2zM-1.5,-4h0.5v0.5h-0.5zM-0.5,-4h0.5v0.5h-0.5zM1,-4h1v0.5h-1zM-2,1h0.5v0.5h-0.5zM0.5,1h1v0.5h-1z',
    },
    {
      paint: [
        ['ginkgoYellow', 0.64],
        ['parasolStripe', 0.36],
      ],
      d: 'M0.5,-6h0.5v0.5h-0.5zM-2,-5.5h3v0.5h-3zM-2,-5h2v0.5h-2z',
    },
  ],
  pixels: 92,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
